/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MedCrossIcon16Light } from './MedCrossIcon16Light';
import { MedCrossIcon16Regular } from './MedCrossIcon16Regular';
import { MedCrossIcon16Solid } from './MedCrossIcon16Solid';
import { MedCrossIcon20Light } from './MedCrossIcon20Light';
import { MedCrossIcon20Regular } from './MedCrossIcon20Regular';
import { MedCrossIcon20Solid } from './MedCrossIcon20Solid';
import { MedCrossIcon24Regular } from './MedCrossIcon24Regular';
import { MedCrossIcon24Solid } from './MedCrossIcon24Solid';
import { MedCrossIcon32Regular } from './MedCrossIcon32Regular';
import { MedCrossIcon64Regular } from './MedCrossIcon64Regular';
var sizes = {
    16: {
        light: MedCrossIcon16Light,
        regular: MedCrossIcon16Regular,
        solid: MedCrossIcon16Solid,
    },
    20: {
        light: MedCrossIcon20Light,
        regular: MedCrossIcon20Regular,
        solid: MedCrossIcon20Solid,
    },
    24: {
        regular: MedCrossIcon24Regular,
        solid: MedCrossIcon24Solid,
    },
    32: {
        regular: MedCrossIcon32Regular,
    },
    64: {
        regular: MedCrossIcon64Regular,
    },
};
export var MedCrossIcon = forwardRef('MedCrossIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
